import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { delay } from 'rxjs/internal/operators/delay';
import { tap } from 'rxjs/internal/operators/tap';
import { DeviceScreenshotZoomDialogComponent } from 'src/app/components/devices-components/device-screenshot-card/device-screenshot-zoom-dialog/device-screenshot-zoom-dialog.component';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { DeviceInfo } from 'src/app/models/device-models/device-info-model/device-info.model';
import { DevicesDevicesService } from 'src/app/services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-device-screenshot-card',
  templateUrl: './device-screenshot-card.component.html',
  styleUrls: ['./device-screenshot-card.component.scss']
})
export class DeviceScreenshotCardComponent implements OnInit, OnDestroy {

  @Input() deviceInfo: DeviceInfo;
  takeScreenshotSubscription: Subscription;
  showButton: boolean;

  constructor(private dialog: MatDialog,
              private devicesDevicesService: DevicesDevicesService,
              private snackbarService: SnackBarService,
              private spinnerService: SpinnerService) {
                this.showButton = true;
              }

  ngOnInit() { }

  public takeScreenshot() {
    this.showButton = false;
    this.spinnerService.show('take-screenshot-spinner');
    this.takeScreenshotSubscription = this.devicesDevicesService.takeScreenshot(this.deviceInfo.InternalId).pipe(
      delay(3000),
      tap(o => this.showButton = true),
      tap(o => this.spinnerService.hide('take-screenshot-spinner')),
      tap(o => this.devicesDevicesService.refreshDevice()),
      catchError(error => {
        this.showButton = true;
        this.spinnerService.hide('take-screenshot-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  public zoom() {
    const dialogRef = this.dialog.open(DeviceScreenshotZoomDialogComponent, { data: { deviceInfo: this.deviceInfo } });
  }

  ngOnDestroy() {
    if (this.takeScreenshotSubscription) { this.takeScreenshotSubscription.unsubscribe(); }
  }
}
